module.exports = __webpack_public_path__ + "img/10_88.cdeb4b41.png";